import { useRef, useState, useEffect } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Models
import IQuiz from 'models/Quiz';
// Types
import QuizTypes from 'types/QuizTypes';
// Actions
import { setQuestionStart, setQuestionEnd } from 'store/player/playerSlice';
// Selectors
import { selectQuestionStart } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';

const useQuestionInterval = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const questionStart:boolean = useAppSelector(selectQuestionStart);

  const seconds = quiz.type === QuizTypes.Scoring ? (quiz.questionTimeout || 10) : 30;

  const interval = useRef<any>(null);
  const intervalTime = 10;
  const maxScore = seconds * 100;

  const [ score, setScore ] = useState(maxScore);
  const [ time, setTime ] = useState<number>(0);

  const width = score / seconds;

  const handleClearInterval = () => {
    if ( interval.current ) clearInterval(interval.current);
  }

  useEffect(() => {
    if ( questionStart ){
      const start = new Date().getTime();

      interval.current = setInterval(() => {
        const end = new Date().getTime();
        const time = Math.ceil((end - start)/10);
        const nextScore = maxScore - time;
        setScore(nextScore);
        setTime(time / 1000);
      }, intervalTime);
    } else {
      handleClearInterval();
    }
    // eslint-disable-next-line
  }, [questionStart]);

  useEffect(() => {
    if ( score < 1 ){
      setScore(0);
      dispatch(setQuestionStart(false));
      dispatch(setQuestionEnd(true));
    }
    // eslint-disable-next-line
  }, [score]);

  return { score, time, width };
}

export default useQuestionInterval;